var getAssetAspectRatio = assetAspectRatio => {
  switch (assetAspectRatio) {
    case '1 / 1':
      return '1 / 1';

    case '16 / 9':
      return '16 / 9';

    case '4 / 3':
      return '4 / 3';

    default:
      return '7 / 3';
  }
};

export var promotionalModalTheme = {
  baseStyle: _ref => {
    var {
      assetAspectRatio
    } = _ref;
    return {
      header: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flexShrink: 0,
        gap: 'xxl',
        paddingBottom: {
          xs: 's',
          s: 'm'
        }
      },
      asset: {
        borderTopRadius: 'l',
        display: 'block',
        justifyContent: 'center',
        width: '100%',
        height: 'fit-content',
        maxHeight: '560px',
        aspectRatio: getAssetAspectRatio(assetAspectRatio),
        '> *': {
          aspectRatio: 'inherit'
        }
      }
    };
  }
};
//# sourceMappingURL=PromotionalModal.theme.js.map